// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".density-bar{position:absolute;height:100%;width:15px;right:0;cursor:default;overflow:hidden}.density-bar.density-bar-invis{visibility:hidden;pointer-events:none}.density-bar .density-content{cursor:pointer;width:100%;position:relative}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
